import * as yup from "yup";
import { programTypes, REFERRAL_STATUS } from "./common";
const MAX_FILE_SIZE = 10 * 1024 * 1024;

function getExtension(filename) {
  if (!filename) return "";
  const parts = filename.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
}
export const referralWithMemberInitialValues = (selectedMamber) =>
  selectedMamber
    ? {
        // name: selectedMamber?.name || "",
        first_name:
          selectedMamber?.member?.first_name ||
          selectedMamber?.first_name ||
          "",
        last_name:
          selectedMamber?.member?.last_name || selectedMamber?.last_name || "",
        fullName: `${selectedMamber?.member?.first_name ||
          selectedMamber?.first_name ||
          ""} ${selectedMamber?.member?.last_name ||
          selectedMamber?.last_name ||
          ""}`,
        date_of_birth:
          selectedMamber?.member?.date_of_birth ||
          selectedMamber?.date_of_birth ||
          "",
        cin: selectedMamber?.member?.cin || selectedMamber?.cin || "",
        aica_account:
          selectedMamber?.member?.aica_account ||
          selectedMamber?.aica_account ||
          "",
        health_plan_id:
          selectedMamber?.member?.health_plan?.id ||
          selectedMamber?.health_plan?.id ||
          "",
        //referral information

        referring_provider: selectedMamber?.referring_provider || "",
        referral_programe: selectedMamber?.referral_programe || "",
        referral_source: selectedMamber?.referral_source || "",
        programe_enrollement:
          programTypes.filter((item) =>
            selectedMamber?.programe_enrollement?.includes(item.value)
          ) || [],
        enrollement: selectedMamber?.enrollement,
        referral_status: selectedMamber?.referral_status,
        if_number: selectedMamber?.referral_status
          ? selectedMamber?.if_number || ""
          : "",
        denial_reason: selectedMamber?.denial_reason,
        current_living_situation: selectedMamber?.current_living_situation,
        attachment: selectedMamber?.attachment,

        //Authorizations information

        auth_number: selectedMamber?.referral_status
          ? selectedMamber?.auth_number || ""
          : "",
        start_date: selectedMamber?.referral_status
          ? selectedMamber?.start_date || ""
          : "",
        end_date: selectedMamber?.referral_status
          ? selectedMamber?.end_date || ""
          : "",
        approved_days: selectedMamber?.referral_status
          ? selectedMamber?.approved_days || ""
          : "",

        content_type: selectedMamber?.content_type || "",
        file_name: selectedMamber?.file_name || "",
      }
    : {
        // name: "",
        first_name: "",
        last_name: "",
        date_of_birth: "",
        cin: "",
        aica_account: "",
        health_plan_id: "",
        //referral information

        referring_provider: "",
        referral_contact_id: "",
        referral_source: "",
        community_engagement_id: "",
        referral_status: "",
        programe_enrollement: [],
        // enrollement: "",
        referral_programe: "",
        denial_reason: "",
        // if_number: "",
        current_living_situation: "",
        attachment: null,
        //Authorizations information
        // auth_number: "",
        // start_date: "",
        // end_date: "",
        // approved_days: "",
        content_type: "",
        file_name: "",
      };
export const referralWithMemberValidationSchema = yup.object().shape({
  // name: yup.string(),
  first_name: yup.string(),
  last_name: yup.string(),
  // .required("Name is required"),
  date_of_birth: yup.string(),
  // .required("Date of Birth is required"),
  cin: yup.string(),
  // .required("CIN is required"),
  if_number: yup.string(),
  aica_account: yup.string(),
  // .required("AICA Account No. is required"),
  health_plan_id: yup.string(),
  // .required("Health Plan is required"),

  referring_provider: yup.string().required("Referring provider is required"),
  referral_source: yup.string().required("Referral source is required"),
  programe_enrollement: yup
    .array()
    .min(1, "Program enrollment cannot be empty")
    .required("Program enrollment is required"),

  referral_programe: yup.string().required("Referral program is required"),
  referral_status: yup.string().required("Referral status is required"),
  denial_reason: yup.string().when("referral_status", {
    is: REFERRAL_STATUS.Denied,
    then: yup.string().required("Denial Reason is required"),
    otherwise: yup.string().notRequired(),
  }),
  current_living_situation: yup
    .string()
    .required("Current Living Situation is required"),
  //Authorizations information
  auth_number: yup.string().when("referral_status", {
    is: REFERRAL_STATUS.Approved,
    then: yup.string().required("Auth Number is required"),
    otherwise: yup.string().notRequired(),
  }),
  start_date: yup.string().when("referral_status", {
    is: REFERRAL_STATUS.Approved,
    then: yup.string().required("Auth Start Date is required"),
    otherwise: yup.string().notRequired(),
  }),
  end_date: yup.string().when("referral_status", {
    is: REFERRAL_STATUS.Approved,
    then: yup.string().required("Auth End Date is required"),
    otherwise: yup.string().notRequired(),
  }),
  approved_days: yup.string().when("referral_status", {
    is: REFERRAL_STATUS.Approved,
    then: yup.string().required("Number of Approved Days is required"),
    otherwise: yup.string().notRequired(),
  }),
  attachment: yup
    .mixed()
    .nullable()
    .test("fileType", "File must be of type PDF, PNG, or JPEG", (file) => {
      if (!file) return true;
      const allowedExtensions = ["pdf", "png", "jpeg", "jpg"];
      const ext = getExtension(file.name);
      return allowedExtensions.includes(ext);
    })
    .test("fileSize", "File size must be less than 10 MB", (file) => {
      if (!file) return true;
      return file.size <= MAX_FILE_SIZE;
    }),
});
export const REFERRALS_COLUMNS = [
  { columnKey: "name", label: "Name", isSortable: true },
  { columnKey: "cin", label: "CIN", isSortable: true },
  { columnKey: "date_of_birth", label: "Date of Birth", isSortable: true },
  { columnKey: "county", label: "County", isSortable: true },
  {
    columnKey: "referral_program",
    label: "Referral Program",
    isSortable: false,
  },
  {
    columnKey: "referral_status",
    label: "Referral Status",
    isSortable: true,
  },
  { columnKey: "created_at", label: "Created Date", isSortable: true },
];
